var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    opacity: 0.4,
    d: "M13.9742 15.8169H6.02422C5.67422 15.8169 5.35756 15.5919 5.24089 15.2669L1.77422 5.55853C1.49922 4.78353 2.38256 4.1252 3.04089 4.6002L6.37422 6.98353C6.81589 7.3002 7.44922 7.10853 7.64089 6.6002L9.21589 2.4002C9.48256 1.6752 10.5076 1.6752 10.7742 2.4002L12.3492 6.6002C12.5409 7.11686 13.1659 7.3002 13.6159 6.98353L16.9492 4.6002C17.6159 4.1252 18.4909 4.79186 18.2159 5.55853L14.7492 15.2669C14.6409 15.5919 14.3242 15.8169 13.9742 15.8169Z",
    fill: "#E8F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M14.1673 18.333H5.83398C5.49232 18.333 5.20898 18.0497 5.20898 17.708C5.20898 17.3663 5.49232 17.083 5.83398 17.083H14.1673C14.509 17.083 14.7923 17.3663 14.7923 17.708C14.7923 18.0497 14.509 18.333 14.1673 18.333Z",
    fill: "#E8F0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-2",
    d: "M12.0827 12.292H7.91602C7.57435 12.292 7.29102 12.0087 7.29102 11.667C7.29102 11.3253 7.57435 11.042 7.91602 11.042H12.0827C12.4243 11.042 12.7077 11.3253 12.7077 11.667C12.7077 12.0087 12.4243 12.292 12.0827 12.292Z",
    fill: "#E8F0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.36862bac9826d949e13c5e89c83d246a.svg";
export { ForwardRef as ReactComponent };